(function ($) { // Hide scope, no $ conflict

	'use strict';
	var pluginName = 'passengersPicker';
	$.JQPlugin.createPlugin({

		name: pluginName,

		defaultRenderer: {
			picker: '<div class="component-passenger">{content}{link:clear}{link:close}<div class="clear-fix"></div></div>',

			typeCheckBlock: '<div class="fields fields-check">{radioBlock}</div>',
			typeCheckItem: '<label name="label_{x.id}" for="{x.name}">{x.title}</label><input type="checkbox" id="{x.id}" name="{x.name}" value="{x.value}" {x.checked}/>',

			typeRadioBlock: '<div class="fields fields-radio">{radioBlock}</div>',
			typeRadioItem: '<label name="label_{x.id}" for="{x.name}"><span>{x.title}</span><span>{x.desc}</span></label><input type="radio" id="{x.id}" name="{x.name}" value="{x.value}" {x.checked}/>',

			typeRangeSetBlock: '<div class="fields fields-rangeSet" data-max="{x.max}">{rangeSetBlock}</div>',
			typeRangeSetItem: '<div class="fields-row"><label name="label_{x.id}" for="{x.name}">{x.title}</label>{button:decreaseCounter}<input type="text" id="{x.id}" name="{x.name}" value="{x.value}" data-min="{x.min}" data-max="{x.max}"/>{button:increaseCounter}</div>',

			typeRangeSetCollectionBlock: '<div class="fields fields-rangeSetCollection" data-max="{x.max}" data-maxset="{x.maxSet}" data-json="{x.json}">{button:addRangeSet}{button:removeRangeSet}{rangeSetCollectionBlock}</div>',
			typeRangeSetCollectionItem: '<div class="fields fields-rangeSetItem" data-max="{x.max}"><label>{x.title}</label>{rangeSetCollectionItems}</div>',
			typeRangeSetCollectionSubItem: '<div class="fields-row" data-json="{x.json}"><label name="label_{x.id}" for="{x.name}" >{x.title}</label>{button:decreaseCounter}<input type="text" id="{x.id}" name="{x.name}" value="{x.value}" data-min="{x.min}" data-max="{x.max}" data-type="{x.type}"/>{button:increaseCounter}<div class="clear"></div>{rangeSetCollectionSubItemSubLevel}</div>',
			typeRangeSetCollectionSubItemSubLevel: '<div class="fields-row fields-row-sublevel" style="background-color: pink; display: block"><label name="label_{x.id}" for="{x.name}">{x.title}</label>{button:decreaseCounter}<input type="hidden" id="{x.id}" name="{x.name}" value="{x.value}" data-min="{x.min}" data-max="{x.max}" class="sublevel"/><div class="sublevel-title" data-index="{xx.value}" data-title="از {xx.value-1} تا {xx.value} سال"></div>{button:increaseCounter}</div>',
			rtlClass: 'passengers-rtl',
			commandClass: 'passengers-cmd',
			commandButtonClass: '',
			commandLinkClass: '',
			disabledClass: 'passengers-disabled'
		},

		commands: {

			clear: {
				text: 'clearText',
				status: 'clearStatus', // Clear the datepicker
				keystroke: { keyCode: 35, ctrlKey: true }, // Ctrl + End
				enabled: function () { return true; },
				date: function () { return null; },
				action: function () {
					plugin.clear(this);
				}
			},
			close: {
				text: 'closeText',
				status: 'closeStatus', // Close the datepicker
				keystroke: { keyCode: 27 }, // Escape
				enabled: function () { return true; },
				date: function () { return null; },
				action: function (inst, obj) {
					plugin.hide(this, obj);
				}
			},
			submit: {
				text: 'submitText',
				status: 'submitStatus', // Close the datepicker
				keystroke: { keyCode: 27 }, // Escape
				enabled: function () { return true; },
				date: function () { return null; },
				action: function (inst, obj) {
					plugin.submit(this, obj);
				}
			},
			cancel: {
				text: 'cancelText',
				status: 'cancelStatus', // Close the datepicker
				keystroke: { keyCode: 27 }, // Escape
				enabled: function () { return true; },
				date: function () { return null; },
				action: function (inst, obj) {
					plugin.cancel(this, obj);
				}
			},
			increaseCounter: {
				text: 'increaseCounterText',
				status: 'increaseCounterStatus', // Close the datepicker
				keystroke: { keyCode: 27 }, // Escape
				enabled: function () { return true; },
				date: function () { return null; },
				action: function (inst, obj) {
					plugin.increaseCounter(this, obj);
				}
			},
			decreaseCounter: {
				text: 'decreaseCounterText',
				status: 'decreaseCounterStatus', // Close the datepicker
				keystroke: { keyCode: 27 }, // Escape
				enabled: function () { return true; },
				date: function () { return null; },
				action: function (inst, obj) {
					plugin.decreaseCounter(this, obj);
				}
			},
			addRangeSet: {
				text: 'addRangeSetText',
				status: 'addRangeSetStatus', // Close the datepicker
				keystroke: { keyCode: 27 }, // Escape
				enabled: function () { return true; },
				date: function () { return null; },
				action: function (inst, obj) {
					plugin.addRangeSet(this, obj);
				}
			},
			removeRangeSet: {
				text: 'removeRangeSetText',
				status: 'removeRangeSetStatus', // Close the datepicker
				keystroke: { keyCode: 27 }, // Escape
				enabled: function () { return true; },
				date: function () { return null; },
				action: function (inst, obj) {
					plugin.removeRangeSet(this, obj);
				}
			}
		},

		defaultOptions: {

			pickerClass: '',
			showOnFocus: true,
			showTrigger: null,
			showAnim: 'show', //show
			showOptions: {},
			showSpeed: 'normal',
			popupContainer: null,
			alignment: 'bottom',
			calculateWeek: null,
			localNumbers: false,
			useMouseWheel: true,
			onInit: null,
			onShow: null,
			onSelect: null,
			onAfterSelect: null,
			onClose: null,
			altField: null,
			altFormat: null,
			constrainInput: true,
			manualClose: false,
			structurePreset: "flight",
			structure: null,
			commands: {}, // this.commands,
			device: "desktop",
			storageKey: '',
			clickOutsideClose: true
		},

		regionalOptions: { // Available regional settings, indexed by language/country code
			'': { // Default regional settings - English/US
				renderer: {}, // this.defaultRenderer
				clearText: 'پاک کردن ',
				clearStatus: 'پاک کردن',
				closeText: 'بستن ',
				closeStatus: 'بستن',
				cancelText: 'لغو',
				cancelStatus: 'لغو',
				submitText: 'تایید',
				submitStatus: 'تایید',
				increaseCounterText: '+',
				increaseCounterStatus: 'افزودن',
				decreaseCounterText: '-',
				decreaseCounterStatus: 'کاستن',
				addRangeSetText: 'افزودن',
				addRangeSetStatus: 'افزودن',
				removeRangeSetText: 'حذف',
				removeRangeSetStatus: 'حذف',
				isRTL: false

			}
		},

		_disabled: [],

		_popupClass: 'passengers-popup', // Marker for popup division
		_triggerClass: 'passengers-trigger', // Marker for trigger element
		_disableClass: 'passengers-disable', // Marker for disabled element

		_init: function () {
			this.defaultOptions.commands = this.commands;
			this.regionalOptions[''].renderer = this.defaultRenderer;

			this._super();
		},

		_instSettings: function (elem, options) { // jshint unused:false
			return {
				selectedDates: [], drawDate: null, pickingRange: false,
				inline: ($.inArray(elem[0].nodeName.toLowerCase(), ['div', 'span']) > -1),
				get: function (name) { // Get a setting value, computing if necessary
					// if ($.inArray(name, ['defaultDate', 'minDate', 'maxDate']) > -1) { // Decode date settings
					// 	return this.options.calendar.determineDate(this.options[name], null,
					// 		this.selectedDates[0], this.get('dateFormat'), this.getConfig());
					// }
					// if (name === 'dateFormat') {
					// 	return this.options.dateFormat || this.options.calendar.local.dateFormat;
					// }
					return this.options[name];
				}
			};
		},

		_saveState: function (elem, inst, force) {
			if (force || !inst.options.manualClose) {
				var div = inst.div;
				var structure = inst.options.structure;
				$.each(structure,
					function (i, v) {
						var field = $(div.find(".component-passenger").children(".fields").get(i));
						if (field.hasClass("fields-" + v.type)) {
							switch (v.type) {
								case "radio":
									var inputs = field.find("input[type='radio']");
									var valuex = field.find("input[type='radio']:checked").val();
									$.each(inputs,
										function (ii, vv) {
											v.items[ii].checked = (v.items[ii].value == valuex);
										});
									break;
								case "check":
									var inputsc = field.find("input[type='checkbox']");
									var valuexc = field.find("input[type='checkbox']:checked").val();
									$.each(inputsc,
										function (ii, vv) {
											v.items[ii].checked = (v.items[ii].value == valuexc);
										});
									break;
								case "rangeSet":
									var inputs = field.find("input[type='text']");
									$.each(inputs,
										function (ii, vv) {
											v.items[ii].value = $(vv).val();
										});
									break;
								case "rangeSetCollection":
									var items = field.find(".fields-rangeSetItem");
									var vitems = [];
									$.each(items,
										function (ii, vv) {
											var subitems = $(vv).find(".fields-row:not(.fields-row-sublevel)");
											var vclone = JSON.parse(JSON.stringify(v.items[0]));
											vitems.push(vclone);

											$.each(subitems,
												function (iii, vvv) {
													var inputs = $(vvv).find("input:not(.sublevel)");
													$.each(inputs,
														function (iiii, vvvv) {
															vitems[ii].items[iii].value = $(vvvv).val();
														});

													if (vitems[ii].items[iii].type == 'extended') {
														var vvvvitems = [];
														inputs = $(vvv).find("input.sublevel");
														$.each(inputs,
															function (iiii, vvvv) {
																var vvvvclone = JSON.parse(
																	JSON.stringify(
																		vitems[ii].items[iii].items[vitems[ii].items[iii]
																			.items.length -
																		1]));
																vvvvclone.mode = undefined;
																vvvvclone.value = $(vvvv).val();
																vvvvitems.push(vvvvclone);
															});

														//reserved for serialization
														var vvvvclone = JSON.parse(JSON.stringify(
															vitems[ii].items[iii].items[vitems[ii].items[iii].items.length -
															1]));
														vvvvclone.mode = 'reserved';
														vvvvclone.value = '0';
														vvvvitems.push(vvvvclone);

														vitems[ii].items[iii].items = vvvvitems;
													}
												});

										});
									v.items = vitems;
									break;
							}
						}
					});

				if ($.isFunction(inst.options.onSelect)) {
					inst.options.onSelect.apply(elem, [inst, elem, structure, true]);
				}

				if ($.isFunction(inst.options.onAfterSelect)) {
					inst.options.onAfterSelect.apply(elem, [inst, elem, structure]);				
				}
			}
		},

		_structure: function (elem, inst, options) {
			var structure = null;
			var device = inst.options.device;

			switch (inst.options.structurePreset) {
				case "travelduration":
					structure = [
						{
							"title": "Radio[1]",
							"type": "radio",
							"items": [
								{
									"title": "4 روزه",
									"name": "TravelDuration",
									"id": "TravelDuration_1",
									"value": "4"
								},
								{
									"title": "7 روزه",
									"name": "TravelDuration",
									"id": "TravelDuration_2",
									"value": "7"
								},
								{
									"title": "8 روزه",
									"name": "TravelDuration",
									"id": "TravelDuration_3",
									"value": "8"
								},
								{
									"title": "15 روزه",
									"name": "TravelDuration",
									"id": "TravelDuration_4",
									"value": "15",
									"checked": true
								},
								{
									"title": "23 روزه",
									"name": "TravelDuration",
									"id": "TravelDuration_5",
									"value": "23"
								},
								{
									"title": "31 روزه",
									"name": "TravelDuration",
									"id": "TravelDuration_6",
									"value": "31"
								},
								{
									"title": "45 روزه",
									"name": "TravelDuration",
									"id": "TravelDuration_7",
									"value": "45"
								},
								{
									"title": "2 ماهه",
									"name": "TravelDuration",
									"id": "TravelDuration_8",
									"value": "62"
								}
								,
								{
									"title": "3 ماهه",
									"name": "TravelDuration",
									"id": "TravelDuration_9",
									"value": "92"
								},
								{
									"title": "6 ماهه",
									"name": "TravelDuration",
									"id": "TravelDuration_10",
									"value": "182"
								},
								{
									"title": "یکساله",
									"name": "TravelDuration",
									"id": "TravelDuration_11",
									"value": "365"
								}
							]
						}
					];
					break;
				case "flight":
					structure = [
						{
							"title": "RangeSet[1]",
							"name": "rangeSet",
							"type": "rangeSet",
							"max": 9,
							"items": [
								{
									"title": "بزرگسال",
									"desc": "",
									"name": "rangeSet1",
									"value": 1,
									"min": 1,
									"max": -1
								},
								{
									"title": "کودک",
									"desc": "۲ تا ۱۲ سال",
									"name": "rangeSet2",
									"value": 0,
									"min": 0,
									"max": -1
								},
								{
									"title": "نوزاد",
									"desc": "تا ۲ سال",
									"name": "rangeSet3",
									"value": 0,
									"min": 0,
									"max": -1
								}
							]
						},
						{
							"title": "Radio[1]",
							"type": "radio",
							"items": [
								{
									"title": (device === "desktop") ? "اکونومی کلاس" : "اکونومی",
									"name": "FlightClass",
									"id": "FlightClass_1",
									"value": "Economy",
									"checked": true
								},
								{
									"title": (device === "desktop") ? "بیزینس کلاس" : "بیزینس",
									"name": "FlightClass",
									"id": "FlightClass_2",
									"value": "Business"
								},
								{
									"title": (device === "desktop") ? "فرست کلاس" : "فرست",
									"name": "FlightClass",
									"id": "FlightClass_3",
									"value": "First"
								}
							]
						}
					];
					break;
				case "flightclass":
					structure = [
						{
							"title": "Radio[1]",
							"type": "radio",
							"items": [
								{
									"title": (device === "desktop") ? "اکونومی کلاس" : "اکونومی",
									"name": "FlightClass",
									"id": "FlightClass_1",
									"value": "Economy",
									"checked": true
								},
								{
									"title": (device === "desktop") ? "بیزینس کلاس" : "بیزینس",
									"name": "FlightClass",
									"id": "FlightClass_2",
									"value": "Business"
								},
								{
									"title": (device === "desktop") ? "فرست کلاس" : "فرست",
									"name": "FlightClass",
									"id": "FlightClass_3",
									"value": "First"
								}
							]
						}
					];
					break;
				case "passengers":
					structure = [
						{
							"title": "RangeSet[1]",
							"name": "rangeSet",
							"type": "rangeSet",
							"max": 9,
							"items": [
								{
									"title": "بزرگسال",
									"desc": "",
									"name": "rangeSet1",
									"value": 1,
									"min": 1,
									"max": -1
								},
								{
									"title": "کودک",
									"desc": "۲ تا ۱۲ سال",
									"name": "rangeSet2",
									"value": 0,
									"min": 0,
									"max": -1
								},
								{
									"title": "نوزاد",
									"desc": "تا ۲ سال",
									"name": "rangeSet3",
									"value": 0,
									"min": 0,
									"max": -1
								}
							]
						}
					];
					break;
				case "passengers-alone":
					structure = [
						{
							"title": "RangeSet[1]",
							"name": "rangeSet",
							"type": "rangeSet",
							"max": 9,
							"items": [
								{
									"title": "بزرگسال",
									"desc": "",
									"name": "rangeSet1",
									"value": 1,
									"min": 1,
									"max": -1
								},
								{
									"title": "کودک",
									"desc": "۲ تا ۱۲ سال",
									"name": "rangeSet2",
									"value": 0,
									"min": 0,
									"max": -1
								},
								{
									"title": "نوزاد",
									"desc": "تا ۲ سال",
									"name": "rangeSet3",
									"value": 0,
									"min": 0,
									"max": -1
								}
							]
						}
					];
					break;
				case "flighttriptype":
					structure = [
						{
							"title": "Radio[1]",
							"type": "radio",
							"items": [
								{
									"title": (device === "desktop") ? "یک طرفه" : "یکطرفه",
									"name": "TripType",
									"id": "OneWay_x",
									"value": "OneWay",
									"checked": true
								},
								{
									"title": "رفت و برگشت",
									"name": "TripType",
									"id": "RoundTrip_x",
									"value": "RoundTrip",
									"checked": false
								},
								{
									"title": (device === "desktop") ? "چند مسیری" : "چندمسیری",
									"name": "TripType",
									"id": "MultipleDestination_x",
									"value": "MultipleDestination",
									"checked": false
								}
							]
						}
					];
					break;
				case "traintriptype":
					structure = [
						{
							"title": "Radio[1]",
							"type": "radio",
							"items": [

								{
									"title": (device === "desktop") ? "یک طرفه" : "یکطرفه",
									"name": "TripType",
									"id": "OneWay_x",
									"value": "OneWay",
									"checked": true
								},
								{
									"title": "رفت و برگشت",
									"name": "TripType",
									"id": "RoundTrip_x",
									"value": "RoundTrip",

								}
							]
						}
					];
					break;
				case "hotel":
					structure = [
						{
							"title": "RangeSetCollection[1]",
							"name": "rangeSetCollection",
							"type": "rangeSetCollection",
							"max": 16,
							"maxSet": 4,
							"items": [
								{
									"title": "اتاق {ncounter}",
									"type": "rangeSet",
									"max": 4,
									"items": [
										{
											"title": "بزرگسال",
											"name": "adult{guid}",
											"type": "normal",
											"value": 1,
											"min": 1,
											"max": -1
										},
										{
											"title": "کودک",
											"name": "child{guid}",
											"type": "extended",
											"value": 0,
											"min": 0,
											"max": -1,
											"items": [
												{
													"title": "سن کودک {ncounter}",
													"name": "adult{guid}",
													"type": "normal",
													"mode": "reserved",
													"value": 1,
													"min": 1,
													"max": 12
												}
											]
										}
									]
								}
							]
						}
					];
					break;
				case "package":
					structure = [
						{
							"title": "RangeSetCollection[1]",
							"name": "rangeSetCollection",
							"type": "rangeSetCollection",
							"max": 16,
							"maxSet": 4,
							"items": [
								{
									"title": "اتاق {ncounter}",
									"type": "rangeSet",
									"max": 4,
									"items": [
										{
											"title": "بزرگسال",
											"name": "adult{guid}",
											"type": "normal",
											"value": 1,
											"min": 1,
											"max": -1
										},
										{
											"title": "کودک",
											"name": "child{guid}",
											"type": "extended",
											"value": 0,
											"min": 0,
											"max": -1,
											"items": [
												{
													"title": "سن کودک {ncounter}",
													"name": "adult{guid}",
													"type": "normal",
													"mode": "reserved",
													"value": 0,
													"min": 1,
													"max": 12
												}
											]
										}
									]
								}
							]
						}
					];
					break;
				case "flighthotel":
					structure = [
						{
							"title": "RangeSetCollection[1]",
							"name": "rangeSetCollection",
							"type": "rangeSetCollection",
							"max": 16,
							"maxSet": 4,
							"items": [
								{
									"title": "اتاق {counter}",
									"type": "rangeSet",
									"max": 4,
									"items": [
										{
											"title": "بزرگسال",
											"name": "adult{guid}",
											"type": "normal",
											"value": 1,
											"min": 1,
											"max": -1
										},
										{
											"title": "کودک",
											"name": "child{guid}",
											"type": "extended",
											"value": 0,
											"min": 0,
											"max": -1,
											"items": [
												{
													"title": "سن کودک {ncounter}",
													"name": "adult{guid}",
													"type": "normal",
													"mode": "reserved",
													"value": 1,
													"min": 1,
													"max": 12
												}
											]
										}
									]
								}
							]
						},
						{
							"title": "Radio[1]",
							"type": "radio",
							"items": [
								{
									"title": (device === "desktop") ? "اکونومی کلاس" : "اکونومی",
									"name": "FlightClass",
									"id": "FlightClass_1",
									"value": "Economy",
									"checked": true
								},
								{
									"title": (device === "desktop") ? "بیزینس کلاس" : "بیزینس",
									"name": "FlightClass",
									"id": "FlightClass_2",
									"value": "Business"
								},
								{
									"title": (device === "desktop") ? "فرست کلاس" : "فرست",
									"name": "FlightClass",
									"id": "FlightClass_3",
									"value": "First"
								}
							]
						}
					];
					break;
				case "insurance":
					structure = [
						{
							"title": "RangeSet[1]",
							"name": "rangeSet",
							"type": "rangeSet",
							"max": 9,
							"items": [
								{
									"title": "از ۱ تا ۱۲ سال",
									"name": "rangeSet1",
									"value": 0,
									"min": 0,
									"max": -1
								},
								{
									"title": "از ۱۳ تا ۶۵ سال",
									"name": "rangeSet2",
									"value": 1,
									"min": 0,
									"max": -1
								},
								{
									"title": "از ۶۶ تا ۷۰ سال",
									"name": "rangeSet3",
									"value": 0,
									"min": 0,
									"max": -1
								},
								{
									"title": "از ۷۱ تا ۷۵ سال",
									"name": "rangeSet4",
									"value": 0,
									"min": 0,
									"max": -1
								},
								{
									"title": "از ۷۶ تا ۸۰ سال",
									"name": "rangeSet5",
									"value": 0,
									"min": 0,
									"max": -1
								},
								{
									"title": "از ۸۱ تا ۸۵ سال",
									"name": "rangeSet6",
									"value": 0,
									"min": 0,
									"max": -1
								}
							]
						}
					];
					break;
				case "train":
					structure = [
						{
							"title": "RangeSet[1]",
							"name": "rangeSet",
							"type": "rangeSet",
							"max": 9,
							"items": [
								{
									"title": "بزرگسال",
									"desc": "",
									"name": "rangeSet1",
									"value": 1,
									"min": 1,
									"max": -1
								},
								{
									"title": "کودک",
									"desc": "۲ تا ۱۲ سال",
									"name": "rangeSet2",
									"value": 0,
									"min": 0,
									"max": -1
								},
								{
									"title": "نوزاد",
									"desc": "تا ۲ سال",
									"name": "rangeSet3",
									"value": 0,
									"min": 0,
									"max": -1
								}
							]
						},
						{
							"title": "Radio[1]",
							"type": "radio",
							"items": [
								{
									"title": (device === "desktop") ? "مسافرین عادی" : "عادی",
									"name": "TrainClass",
									"id": "TrainClass_1",
									"value": "F",
									"checked": true
								},
								{
									"title": (device === "desktop") ? "ویژه برادران" : "برادران",
									"name": "TrainClass",
									"id": "TrainClass_2",
									"value": "B"
								},
								{
									"title": (device === "desktop") ? "ویژه خواهران" : "خواهران",
									"name": "TrainClass",
									"id": "TrainClass_3",
									"value": "S"
								}
							]
						}
					];
					break;
				case "trainclass":
					structure = [
						{
							"title": "Radio[1]",
							"type": "radio",
							"items": [
								{
									"title": (device === "desktop") ? "مسافرین عادی" : "عادی",
									"name": "TrainClass",
									"id": "TrainClass_1",
									"value": "F",
									"checked": true
								},
								{
									"title": (device === "desktop") ? "ویژه برادران" : "برادران",
									"name": "TrainClass",
									"id": "TrainClass_2",
									"value": "B"
								},
								{
									"title": (device === "desktop") ? "ویژه خواهران" : "خواهران",
									"name": "TrainClass",
									"id": "TrainClass_3",
									"value": "S"
								}
							]
						},
						{
							"title": "Check[1]",
							"type": "check",
							"items": [
								{
									"title": "کوپه دربست",
									"name": "ExclusiveTrain",
									"id": "ExclusiveTrain",
									"value": "true"
								}
							]
						}
					];
					break;
				default:
					structure = null;
					break;
			}

			inst.options.structure = structure;

			if ($.isFunction(inst.options.onInit)) {
				inst.options.onInit.apply(elem, [inst, elem, structure]);
			}

			if ($.isFunction(inst.options.onSelect)) {
				inst.options.onSelect.apply(elem, [inst, elem, inst.options.structure, false]);
			}

			if ($.isFunction(inst.options.onAfterSelect)) {
				inst.options.onAfterSelect.apply(elem, [inst, elem, inst.options.structure]);
			}

		},

		_postAttach: function (elem, inst) {
			if (inst.inline) {
				this._update(elem[0]);
				if ($.fn.mousewheel) {
					elem.mousewheel(this._doMouseWheel);
				}
			}
			else {
				this._attachments(elem, inst);
				elem.on('keydown.' + inst.name, this._keyDown).on('keypress.' + inst.name, this._keyPress).
					on('keyup.' + inst.name, this._keyUp);
				if (elem.attr('disabled')) {
					this.disable(elem[0]);
				}
			}
		},

		_optionsChanged: function (elem, inst, options) {
			this._structure(elem, inst, options);
			$.extend(inst.options, options);

			// this.setDate(elem[0], dates, null, false, true);

			if (!inst.inline) {
				this._attachments(elem, inst);
			}
			if (inst.inline || inst.div) {
				this._update(elem[0]);
			}
		},

		_attachments: function (elem, inst) {
			elem.off('focus.' + inst.name);
			if (inst.options.showOnFocus) {
				elem.on('focus.' + inst.name, this.show);
			}
			if (inst.trigger) {
				inst.trigger.remove();
			}
			var trigger = inst.options.showTrigger;
			inst.trigger = (!trigger ? $([]) :
				$(trigger).clone().removeAttr('id').addClass(this._triggerClass)
				[inst.options.isRTL ? 'insertBefore' : 'insertAfter'](elem).
					click(function () {
						if (!plugin.isDisabled(elem[0])) {
							plugin[plugin.curInst === inst ? 'hide' : 'show'](elem[0]);
						}
					}));
			this._autoSize(elem, inst);
			// var dates = this._extractDates(inst, elem.val());
			// if (dates) {
			// 	this.setDate(elem[0], dates, null, true);
			// }
			// var defaultDate = inst.get('defaultDate');
			// if (inst.options.selectDefaultDate && defaultDate && inst.selectedDates.length === 0) {
			// 	this.setDate(elem[0], (defaultDate || inst.options.calendar.today()).newDate());
			// }
		},

		_autoSize: function (elem, inst) {
			// if (inst.options.autoSize && !inst.inline) {
			// 	var calendar = inst.options.calendar;
			// 	var date = calendar.newDate(2009, 10, 20); // Ensure double digits
			// 	var dateFormat = inst.get('dateFormat');
			// 	if (dateFormat.match(/[DM]/)) {
			// 		var findMax = function(names) {
			// 			var max = 0;
			// 			var maxI = 0;
			// 			for (var i = 0; i < names.length; i++) {
			// 				if (names[i].length > max) {
			// 					max = names[i].length;
			// 					maxI = i;
			// 				}
			// 			}
			// 			return maxI;
			// 		};
			// 		date.month(findMax(calendar.local[dateFormat.match(/MM/) ? // Longest month
			// 			'monthNames' : 'monthNamesShort']) + 1);
			// 		date.day(findMax(calendar.local[dateFormat.match(/DD/) ? // Longest day
			// 			'dayNames' : 'dayNamesShort']) + 20 - date.dayOfWeek());
			// 	}
			// 	inst.elem.attr('size', date.formatDate(dateFormat,
			// 		{localNumbers: inst.options.localnumbers}).length);
			// }
		},

		_preDestroy: function (elem, inst) {
			if (inst.trigger) {
				inst.trigger.remove();
			}
			elem.empty().off('.' + inst.name);
			if (inst.inline && $.fn.mousewheel) {
				elem.unmousewheel();
			}
			if (!inst.inline && inst.options.autoSize) {
				elem.removeAttr('size');
			}
		},

		multipleEvents: function (fns) { // jshint unused:false
			var funcs = arguments;
			return function () {
				for (var i = 0; i < funcs.length; i++) {
					funcs[i].apply(this, arguments);
				}
			};
		},

		enable: function (elem) {
			elem = $(elem);
			if (!elem.hasClass(this._getMarker())) {
				return;
			}
			var inst = this._getInst(elem);
			if (inst.inline) {
				elem.children('.' + this._disableClass).remove().end().
					find('button,select').prop('disabled', false).end().
					find('a').attr('href', '#');
			}
			else {
				elem.prop('disabled', false);
				inst.trigger.filter('button.' + this._triggerClass).prop('disabled', false).end().
					filter('img.' + this._triggerClass).css({ opacity: '1.0', cursor: '' });
			}
			this._disabled = $.map(this._disabled,
				function (value) { return (value === elem[0] ? null : value); }); // Delete entry
		},

		disable: function (elem) {
			elem = $(elem);
			if (!elem.hasClass(this._getMarker())) {
				return;
			}
			var inst = this._getInst(elem);
			if (inst.inline) {
				var inline = elem.children(':last');
				var offset = inline.offset();
				var relOffset = { left: 0, top: 0 };
				inline.parents().each(function () {
					if ($(this).css('position') === 'relative') {
						relOffset = $(this).offset();
						return false;
					}
				});
				var zIndex = elem.css('zIndex');
				zIndex = (zIndex === 'auto' ? 0 : parseInt(zIndex, 10)) + 1;
				elem.prepend('<div class="' + this._disableClass + '" style="' +
					'width: ' + inline.outerWidth() + 'px; height: ' + inline.outerHeight() +
					'px; left: ' + (offset.left - relOffset.left) + 'px; top: ' +
					(offset.top - relOffset.top) + 'px; z-index: ' + zIndex + '"></div>').
					find('button,select').prop('disabled', true).end().
					find('a').removeAttr('href');
			}
			else {
				elem.prop('disabled', true);
				inst.trigger.filter('button.' + this._triggerClass).prop('disabled', true).end().
					filter('img.' + this._triggerClass).css({ opacity: '0.5', cursor: 'default' });
			}
			this._disabled = $.map(this._disabled,
				function (value) { return (value === elem[0] ? null : value); }); // Delete entry
			this._disabled.push(elem[0]);
		},

		isDisabled: function (elem) {
			return (elem && $.inArray(elem, this._disabled) > -1);
		},

		show: function (elem) {
			elem = $(elem.target || elem);
			var inst = plugin._getInst(elem);
			if (plugin.curInst === inst) {
				return;
			}
			if (plugin.curInst) {
				plugin.hide(plugin.curInst, true);
			}
			if (!$.isEmptyObject(inst)) {
				// Retrieve existing date(s)
				inst.lastVal = null;
				//inst.selectedDates = plugin._extractDates(inst, elem.val());
				inst.pickingRange = false;
				plugin.curInst = inst;
				// Generate content
				plugin._update(elem[0], false);
				// Adjust position before showing
				//var offset = plugin._checkOffset(inst);
				//inst.div.css({left: offset.left, top: offset.top});
				// And display
				var showAnim = inst.options.showAnim;
				var showSpeed = inst.options.showSpeed;
				showSpeed = (showSpeed === 'normal' && $.ui &&
					parseInt($.ui.version.substring(2)) >= 8 ? '_default' : showSpeed);
				if ($.effects && ($.effects[showAnim] || ($.effects.effect && $.effects.effect[showAnim]))) {
					var data = inst.div.data(); // Update old effects data
					for (var key in data) {
						if (key.match(/^ec\.storage\./)) {
							data[key] = inst._mainDiv.css(key.replace(/ec\.storage\./, ''));
						}
					}
					inst.div.data(data).show(showAnim, inst.options.showOptions, showSpeed);
				}
				else {
					inst.div[showAnim || 'show'](showAnim ? showSpeed : 0);
				}
			}
			if (isMobile()) {
				setTimeout(function () {
					if ($(".passengers-popup").length > 0) {
						$('body').css('overflow', 'hidden')
					}
				}, 200)
            }
			$("#rangeSet2").parent().addClass("childClick")
			$("#rangeSet1").parent().addClass("adultClick")

			ClickRemoveErrorCount(".childClick")
			ClickRemoveErrorCount(".adultClick")
		},

		_update: function (elem, hidden) {
			elem = $(elem.target || elem);
			var inst = plugin._getInst(elem);
			if (!$.isEmptyObject(inst)) {
				if (inst.inline || plugin.curInst === inst) {

				}
				if (inst.inline) {
					var index = $('a, :input', elem).index($(':focus', elem));
					elem.html(this._generateContent(elem[0], inst));
					var focus = elem.find('a, :input');
					focus.eq(Math.max(Math.min(index, focus.length - 1), 0)).focus();
				}
				else if (plugin.curInst === inst) {
					if (!inst.div) {
						inst.div = $('<div></div>').addClass(this._popupClass).
							css({
								display: (hidden ? 'none' : 'static'), position: 'absolute' //,
								//left: elem.offset().left, top: elem.offset().top + elem.outerHeight()
							}).
							appendTo($(inst.options.popupContainer || 'body'));
						if ($.fn.mousewheel) {
							inst.div.mousewheel(this._doMouseWheel);
						}
					}
					inst.div.html(this._generateContent(elem[0], inst));
					elem.focus();
				}
			}

			this.checkActive(elem);
		},

		_updateInput: function (elem, keyUp) {
			var inst = this._getInst(elem);
			if (!$.isEmptyObject(inst)) {
				var value = '';
				// var altValue = '';
				// var sep = (inst.options.multiSelect ? inst.options.multiSeparator :
				// 	inst.options.rangeSeparator);
				// var calendar = inst.options.calendar;
				// var dateFormat = inst.get('dateFormat');
				// var altFormat = inst.options.altFormat || dateFormat;
				//var settings = {localNumbers: inst.options.localNumbers};
				for (var i = 0; i < inst.selectedDates.length; i++) {
					// value += (keyUp ? '' : (i > 0 ? sep : '') +
					// 	calendar.formatDate(dateFormat, inst.selectedDates[i], settings));
					// altValue += (i > 0 ? sep : '') +
					// 	calendar.formatDate(altFormat, inst.selectedDates[i], settings);
				}
				if (!inst.inline && !keyUp) {
					$(elem).val(value);
				}
				//$(inst.options.altField).val(altValue);
				// if ($.isFunction(inst.options.onSelect) && !keyUp && !inst.inSelect) {
				// 	inst.inSelect = true; // Prevent endless loops
				// 	inst.options.onSelect.apply(elem, [inst.selectedDates]);
				// 	inst.inSelect = false;
				// }
				$(elem).change();
			}
		},

		_getBorders: function (elem) {
			var convert = function (value) {
				return { thin: 1, medium: 3, thick: 5 }[value] || value;
			};
			return [parseFloat(convert(elem.css('border-left-width'))),
			parseFloat(convert(elem.css('border-top-width')))];
		},

		_checkOffset: function (inst) {
			var base = (inst.elem.is(':hidden') && inst.trigger ? inst.trigger : inst.elem);
			var offset = base.offset();
			var browserWidth = $(window).width();
			var browserHeight = $(window).height();
			if (browserWidth === 0) {
				return offset;
			}
			var isFixed = false;
			$(inst.elem).parents().each(function () {
				isFixed = isFixed || $(this).css('position') === 'fixed';
				return !isFixed;
			});
			var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
			var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
			var above = offset.top - (isFixed ? scrollY : 0) - inst.div.outerHeight();
			var below = offset.top - (isFixed ? scrollY : 0) + base.outerHeight();
			var alignL = offset.left - (isFixed ? scrollX : 0);
			var alignR = offset.left - (isFixed ? scrollX : 0) + base.outerWidth() - inst.div.outerWidth();
			var tooWide = (offset.left - scrollX + inst.div.outerWidth()) > browserWidth;
			var tooHigh = (offset.top - scrollY + inst.elem.outerHeight() +
				inst.div.outerHeight()) > browserHeight;
			inst.div.css('position', isFixed ? 'fixed' : 'absolute');
			var alignment = inst.options.alignment;
			if (alignment === 'topLeft') {
				offset = { left: alignL, top: above };
			}
			else if (alignment === 'topRight') {
				offset = { left: alignR, top: above };
			}
			else if (alignment === 'bottomLeft') {
				offset = { left: alignL, top: below };
			}
			else if (alignment === 'bottomRight') {
				offset = { left: alignR, top: below };
			}
			else if (alignment === 'top') {
				offset = { left: (inst.options.isRTL || tooWide ? alignR : alignL), top: above };
			}
			else { // bottom
				offset = {
					left: (inst.options.isRTL || tooWide ? alignR : alignL),
					top: (tooHigh ? above : below)
				};
			}
			//offset.left = Math.max((isFixed ? 0 : scrollX), offset.left);
			//offset.top = Math.max((isFixed ? 0 : scrollY), offset.top);
			return offset;
		},

		_checkExternalClick: function (event) {
			if (!plugin.curInst) {
				return;
			}
			var elem = $(event.target);
			if (elem.closest('.' + plugin._popupClass + ',.' + plugin._triggerClass).length === 0
				&& !elem.hasClass(plugin._getMarker())) {
				if (plugin.curInst.options.clickOutsideClose) {
					plugin.hide(plugin.curInst);
				};
			}
		},

		submit: function (elem, immediate) {
			var inst = this._getInst(elem);
			this._saveState(elem, inst, true);
			this.hide(elem, true);
		},
		cancel: function (elem, immediate) {
			this.hide(elem, true);
		},
		hide: function (elem, immediate) {
			$('body').css('overflow-y', 'auto')
			if (!elem) {
				return;
			}
			var inst = this._getInst(elem);

			this._saveState(elem, plugin.curInst, true);

			if ($.isEmptyObject(inst)) {
				inst = elem;
			}
			if (inst && inst === plugin.curInst) {
				// if (!inst.options.manualClose)
				// {
				this._saveState(elem, inst);
				//}
				var showAnim = (immediate ? '' : inst.options.showAnim);
				var showSpeed = inst.options.showSpeed;
				showSpeed = (showSpeed === 'normal' && $.ui &&
					parseInt($.ui.version.substring(2)) >= 8 ? '_default' : showSpeed);
				var postProcess = function () {
					if (!inst.div) {
						return;
					}
					inst.div.remove();
					inst.div = null;
					plugin.curInst = null;
					if ($.isFunction(inst.options.onClose)) {
						inst.options.onClose.apply(elem, [inst.selectedDates]);
					}
				};
				inst.div.stop();
				if ($.effects && ($.effects[showAnim] || ($.effects.effect && $.effects.effect[showAnim]))) {
					inst.div.hide(showAnim, inst.options.showOptions, showSpeed, postProcess);
				}
				else {
					var hideAnim = (showAnim === 'slideDown' ? 'slideUp' :
						(showAnim === 'fadeIn' ? 'fadeOut' : 'show'));
					inst.div[hideAnim]((showAnim ? showSpeed : ''), postProcess);
				}
				if (!showAnim) {
					postProcess();
				}
			}
		},

		_keyDown: function (event) {
			var elem = (event.data && event.data.elem) || event.target;
			var inst = plugin._getInst(elem);
			var handled = false;
			var command;
			if (inst.inline || inst.div) {
				if (event.keyCode === 9) { // Tab - close
					plugin.hide(elem);
				}
				else if (event.keyCode === 13) { // Enter - select
					plugin.selectDate(elem,
						$('a.' + inst.options.renderer.highlightedClass, inst.div)[0]);
					handled = true;
				}
				else { // Command keystrokes
					var commands = inst.options.commands;
					for (var name in commands) {
						if (inst.options.commands.hasOwnProperty(name)) {
							command = commands[name];
							/* jshint -W018 */ // Dislikes !!
							if (command.keystroke.keyCode === event.keyCode &&
								!!command.keystroke.ctrlKey === !!(event.ctrlKey || event.metaKey) &&
								!!command.keystroke.altKey === event.altKey &&
								!!command.keystroke.shiftKey === event.shiftKey) {
								/* jshint +W018 */
								plugin.performAction(elem, name);
								handled = true;
								break;
							}
						}
					}
				}
			}
			else { // Show on 'current' keystroke
				command = inst.options.commands.current;
				/* jshint -W018 */ // Dislikes !!
				if (command.keystroke.keyCode === event.keyCode &&
					!!command.keystroke.ctrlKey === !!(event.ctrlKey || event.metaKey) &&
					!!command.keystroke.altKey === event.altKey &&
					!!command.keystroke.shiftKey === event.shiftKey) {
					/* jshint +W018 */
					plugin.show(elem);
					handled = true;
				}
			}
			inst.ctrlKey = ((event.keyCode < 48 && event.keyCode !== 32) || event.ctrlKey || event.metaKey);
			if (handled) {
				event.preventDefault();
				event.stopPropagation();
			}
			return !handled;
		},

		_keyPress: function (event) {
			var inst = plugin._getInst((event.data && event.data.elem) || event.target);
			if (!$.isEmptyObject(inst) && inst.options.constrainInput) {
				var ch = String.fromCharCode(event.keyCode || event.charCode);
				var allowedChars = plugin._allowedChars(inst);
				return (event.metaKey || inst.ctrlKey || ch < ' ' ||
					!allowedChars || allowedChars.indexOf(ch) > -1);
			}
			return true;
		},

		_allowedChars: function (inst) {
			// var allowedChars = (inst.options.multiSelect ? inst.options.multiSeparator :
			// 	(inst.options.rangeSelect ? inst.options.rangeSeparator : ''));
			// var literal = false;
			// var hasNum = false;
			// var dateFormat = inst.get('dateFormat');
			// for (var i = 0; i < dateFormat.length; i++) {
			// 	var ch = dateFormat.charAt(i);
			// 	if (literal) {
			// 		if (ch === '\'' && dateFormat.charAt(i + 1) !== '\'') {
			// 			literal = false;
			// 		}
			// 		else {
			// 			allowedChars += ch;
			// 		}
			// 	}
			// 	else {
			// 		switch (ch) {
			// 			case 'd':
			// 			case 'm':
			// 			case 'o':
			// 			case 'w':
			// 				allowedChars += (hasNum ? '' : '0123456789');
			// 				hasNum = true;
			// 				break;
			// 			case 'y':
			// 			case '@':
			// 			case '!':
			// 				allowedChars += (hasNum ? '' : '0123456789') + '-';
			// 				hasNum = true;
			// 				break;
			// 			case 'J':
			// 				allowedChars += (hasNum ? '' : '0123456789') + '-.';
			// 				hasNum = true;
			// 				break;
			// 			case 'D':
			// 			case 'M':
			// 			case 'Y':
			// 				return null; // Accept anything
			// 			case '\'':
			// 				if (dateFormat.charAt(i + 1) === '\'') {
			// 					allowedChars += '\'';
			// 				}
			// 				else {
			// 					literal = true;
			// 				}
			// 				break;
			// 			default:
			// 				allowedChars += ch;
			// 		}
			// 	}
			// }
			return allowedChars;
		},

		_keyUp: function (event) {
			var elem = (event.data && event.data.elem) || event.target;
			var inst = plugin._getInst(elem);
			if (!$.isEmptyObject(inst) && !inst.ctrlKey && inst.lastVal !== inst.elem.val()) {
				try {
					var dates = plugin._extractDates(inst, inst.elem.val());
					if (dates.length > 0) {
						plugin.setDate(elem, dates, null, true);
					}
				}
				catch (e) {
					// Ignore
				}
			}
			return true;
		},

		_doMouseWheel: function (event, delta) {
			// var elem = (plugin.curInst && plugin.curInst.elem[0]) ||
			// 	$(event.target).closest('.' + plugin._getMarker())[0];
			// if (plugin.isDisabled(elem)) {
			// 	return;
			// }
			// var inst = plugin._getInst(elem);
			// if (inst.options.useMouseWheel) {
			// 	delta = (delta < 0 ? -1 : +1);
			// 	plugin.changeMonth(elem, -inst.options[event.ctrlKey ? 'monthsToJump' : 'monthsToStep'] * delta);
			// }
			event.preventDefault();
		},

		clear: function (elem) {
			var inst = this._getInst(elem);
			if (!$.isEmptyObject(inst)) {
				// inst.selectedDates = [];
				this.hide(elem);
				// var defaultDate = inst.get('defaultDate');
				// if (inst.options.selectDefaultDate && defaultDate) {
				// 	this.setDate(elem, (defaultDate || inst.options.calendar.today()).newDate());
				// }
				// else {
				this._updateInput(elem);
				//}
			}
		},

		checkActive: function (elem) {
			return;
			var plugin = this;
			var inst = plugin._getInst(elem);

			var fields = inst.div.find(".component-passenger").children().filter(".fields");

			fields.each(function (i, v) {
				var field = $(v);
				var fieldClass = field.attr('class').split(/\s+/).filter(x => x.startsWith('fields-'))[0];

				switch (fieldClass) {
					case "fields-rangeSet":
						var increaseButtonClass = inst.options.renderer.commandClass + "-increaseCounter";
						var decreaseButtonClass = inst.options.renderer.commandClass + "-decreaseCounter";
						var increaseButton = field.find("." + increaseButtonClass);
						var decreaseButton = field.find("." + decreaseButtonClass);

						increaseButton.each(function (ii, vv) {
							var input = $(vv);
							var data = plugin._getInputValues(input);

							if (data.sum != null && data.sum < data.maxbox) {
								increaseButton.removeClass(inst.options.disabledClass);
								decreaseButton.toggleClass(inst.options.disabledClass, !(data.sum > data.min));
							}
							else {
								increaseButton.addClass(inst.options.disabledClass);
								decreaseButton.removeClass(inst.options.disabledClass);
							}
						});

						decreaseButton.each(function (ii, vv) {
							var input = $(vv);
							var data = plugin._getInputValues(input);

							if (data.sum > data.min) {
								decreaseButton.removeClass(inst.options.disabledClass);
								increaseButton.toggleClass(inst.options.disabledClass, !(data.sum < data.maxbox));
							}
							else {
								decreaseButton.addClass(inst.options.disabledClass);
								increaseButton.removeClass(inst.options.disabledClass);
							}
						});

						decreaseButton.each(function (ii, vv) {
							var input = $(vv);
							var data = plugin._getInputValues(input);

							input.toggleClass(inst.options.disabledClass, !(data.value > data.min));
						});
						break;
					case "fields-rangeSetCollection":
						var addRangeSetButtonClass = inst.options.renderer.commandClass + "-addRangeSet";
						var removeRangeSetButtonClass = inst.options.renderer.commandClass + "-removeRangeSet";
						//var parentBox = obj.closest(".fields-rangeSetCollection");
						var addRangeSetButton = field.find("." + addRangeSetButtonClass);
						var removeRangeSetButton = field.find("." + removeRangeSetButtonClass);

						var maxSet = field.data("maxset");
						maxSet = maxSet == -1 ? Math.pow(10, 8) : maxSet;
						var children = field.children(".fields-rangeSetItem");
						var count = children.length;

						removeRangeSetButton.toggleClass(inst.options.disabledClass, !(count > 1));
						addRangeSetButton.toggleClass(inst.options.disabledClass, !(maxSet > count));

						var increaseButtonClass = inst.options.renderer.commandClass + "-increaseCounter";
						var decreaseButtonClass = inst.options.renderer.commandClass + "-decreaseCounter";
						var increaseButton = field.find("." + increaseButtonClass);
						var decreaseButton = field.find("." + decreaseButtonClass);

						increaseButton.each(function (ii, vv) {
							var input = $(vv);
							var data = plugin._getInputValues(input);

							if (data.sum != null && data.sum < data.maxbox) {
								if (data.maxboxx != null && data.sumx < data.maxboxx || data.maxboxx == null) {
									increaseButton.removeClass(inst.options.disabledClass);
									decreaseButton.toggleClass(inst.options.disabledClass, !(data.sum > data.min));
								}
								else {
									increaseButton.addClass(inst.options.disabledClass);
									decreaseButton.removeClass(inst.options.disabledClass);
								}
							}
							else {
								increaseButton.addClass(inst.options.disabledClass);
								decreaseButton.removeClass(inst.options.disabledClass);
							}
						});

						decreaseButton.each(function (ii, vv) {

							var input = $(vv);
							var data = plugin._getInputValues(input);

							if (data.sum > data.min) {
								decreaseButton.removeClass(inst.options.disabledClass);
								increaseButton.toggleClass(inst.options.disabledClass,
									!(
										(data.sum < data.maxbox) &&
										((data.maxboxx != null && data.sumx < data.maxboxx) || (data.maxboxx == null))
									)
								);
							}
							else {
								decreaseButton.addClass(inst.options.disabledClass);
								increaseButton.removeClass(inst.options.disabledClass);
							}
						});

						decreaseButton.each(function (ii, vv) {
							var input = $(vv);
							var data = plugin._getInputValues(input);

							input.toggleClass(inst.options.disabledClass, !(data.value > data.min));
						});
						break;
				}
			});

		},

		increaseCounter: function (elem, obj) {
			var conditionalTrainLoication = window.location.pathname
			var data = this._getInputValues(obj);
			var inst = this._getInst(elem);
			var plugin = this;
			var firsValue = $("#rangeSet1").val()
			var lastValue = $("#rangeSet3").val()
			$("#rangeSet2").parent().addClass("childClick")
			$("#rangeSet1").parent().addClass("adultClick")
			
			ClickRemoveErrorCount(".childClick")
			ClickRemoveErrorCount(".adultClick")
			if (data.value < data.max) {
			
				if (data.sum != null) {
					if (conditionalTrainLoication !== '/train/' && $(".passengers-popup").parents("#DomesticTrainSearchForm").length == 0  && data.sum < data.maxbox) // && (data.sumx != null && data.sum < data.sumx))
					{
						
							if (data.maxboxx != null && data.sumx < data.maxboxx || data.maxboxx == null) {
								data.value++;

								if (data.input.data("type") == "extended") {
									var parent = obj.closest('.fields-row');
									var sublevelContainer = parent.find('.sublevel-container');
									var count = sublevelContainer.children().length;
									var json = JSON.parse(parent.data("json").replace(/'/g, '"'));
									var item = json.items[0];

									item.value = item.min; //'0';
									item.mode = undefined;

									var element = this._generateContentTypeRangeSetCollectionItemSubLevel(inst, item, count);
									var elementParsed = this._parseCommands(element, inst);
									sublevelContainer.append(elementParsed);

									plugin._applyTitle(elementParsed, item.min);

								}
							}
                        
						
					}
					if ((conditionalTrainLoication == '/train/' || $(".passengers-popup").parents("#DomesticTrainSearchForm").length !== 0) && data.sum < data.sumTrani) {
						if ($(".passengers-popup").parents("#DomesticTrainSearchForm").length !== 0) {
							if (data.maxboxx != null && data.sumx < data.maxboxx || data.maxboxx == null) {
								data.value++;

								if (data.input.data("type") == "extended") {
									var parent = obj.closest('.fields-row');
									var sublevelContainer = parent.find('.sublevel-container');
									var count = sublevelContainer.children().length;
									var json = JSON.parse(parent.data("json").replace(/'/g, '"'));
									var item = json.items[0];

									item.value = item.min; //'0';
									item.mode = undefined;

									var element = this._generateContentTypeRangeSetCollectionItemSubLevel(inst, item, count);
									var elementParsed = this._parseCommands(element, inst);
									sublevelContainer.append(elementParsed);

									plugin._applyTitle(elementParsed, item.min);

								}
							}
						}
						
					}
				}
				else {
					data.value++;

					var parent = obj.closest('.fields-row');
					plugin._applyTitle(parent, data.value);
				}
			
			}
			
			data.input.val(data.value);
			data.span.text((data.value));
			this._saveState(elem, inst);
			plugin.checkActive(elem);

			if ($(".passengers-popup").parents("#InsuranceSearchForm").length ==0 && conditionalTrainLoication !== '/train/' && $(".passengers-popup").parents("#DomesticTrainSearchForm").length == 0 && lastValue >= firsValue) {
				firsValue = Number(firsValue)
				$("#rangeSet3").val(firsValue)
				$("#rangeSet3").text(firsValue)
				$(".text-error-count").last().removeClass('d-none')
				$(".capacity").addClass('d-none')
			}
			
			var number1 = $("#rangeSet1").val()
			var number2 = $("#rangeSet2").val()
			var number3 = $("#rangeSet3").val()

			var numberSum = Number(number1) + Number(number2) + Number(number3)

			if ((conditionalTrainLoication !== '/train/' || $(".passengers-popup").parents("#DomesticTrainSearchForm").length == 0) && numberSum >= 9) {
				$(".text-error-count").addClass('d-none')
				$(".capacity").last().removeClass('d-none')
			}
			if ((conditionalTrainLoication == '/train/' || $(".passengers-popup").parents("#DomesticTrainSearchForm").length !== 0 )&& numberSum >= 6) {
				$(".text-error-count").addClass('d-none')
				$(".capacity").last().removeClass('d-none')
			}
			if ($('.component-passenger').parents("#InsuranceSearchForm").length !== 0) {
				$(".text-error-count").addClass('d-none')
				$(".capacity").last().addClass('d-none')
			}
			if ($('.component-passenger').parents("#InsuranceSearchForm").length !== 0 && numberSum >= 9) {
				$(".text-error-count").addClass('d-none')
				$(".capacity").last().remove('d-none')
			}
		},
		decreaseCounter: function (elem, obj) {
			var conditionalTrainLoication = window.location.pathname
			var data = this._getInputValues(obj);
			var inst = this._getInst(elem);
			var firsValue = $("#rangeSet1").val()
			var lastValue = $("#rangeSet3").val()
			if (data.value > data.min) {
				data.value--;

				var parent = obj.closest('.fields-row');
				if (data.input.data("type") == "extended") {
					var sublevelContainer = parent.find('.sublevel-container');
					var last = sublevelContainer.children().last();
					last.remove();
				}
				data.input.val(data.value);
				var parent = obj.closest('.fields-row');
				if (parent.hasClass('fields-row-sublevel')) {
					plugin._applyTitle(parent, data.value);
				}
				if (conditionalTrainLoication !== '/train/' && $(".passengers-popup").parents("#DomesticTrainSearchForm").length == 0 && lastValue >= firsValue) {
					if (data.min === 1) {
						firsValue = Number(firsValue)
						$("#rangeSet3").val(data.value)
						$("#rangeSet3").text(data.value)
                    }
					
				}
				if ($('.component-passenger').parents("#InsuranceSearchForm").length !== 0) {
					$(".text-error-count").addClass('d-none')
					$(".capacity").last().addClass('d-none')
                }
				
			}

			this._saveState(elem, inst);
			plugin.checkActive(elem);
			$('.text-error-count').addClass('d-none')
			$('.capacity').addClass('d-none')
			
		},

		addRangeSet: function (elem, obj) {
			var inst = this._getInst(elem);
			var parent = obj.closest(".fields-rangeSetCollection");
			var maxSet = parent.data("maxset");
			maxSet = maxSet == -1 ? Math.pow(10, 8) : maxSet;
			var children = parent.children(".fields-rangeSetItem");
			var count = children.length;
			if (maxSet > count) {
				var data = JSON.parse(parent.data("json").replace(/'/g, '"'));
				var item = data.items[0];
				$.each(item.items, function (i, v) {
					v.items = (v.items != undefined) ? v.items.filter(x => x.mode == 'reserved') : undefined;
				});
				var element = this._generateContentTypeRangeSetCollectionItem(inst, item, count);
				var last = children.last();
				var elementParsed = this._parseCommands(element, inst);
		/*		elementParsed.find("input[type='text'], input[type='hidden']").val('1');*/
				elementParsed.find("input[type='text']:not(:first), input[type='hidden']").val('0');
				last.after(elementParsed);
			}

			this._saveState(elem, inst);
			plugin.checkActive(elem);
		},

		removeRangeSet: function (elem, obj) {
			var inst = this._getInst(elem);
			var parent = obj.closest(".fields-rangeSetCollection");
			var children = parent.children(".fields-rangeSetItem");
			var count = children.length;
			if (count > 1) {
				var last = children.last();
				last.remove();
			}
			this._saveState(elem, inst);
			plugin.checkActive(elem);
		},

		isSelectable: function (elem, date) {
			return true;
			// var inst = this._getInst(elem);
			// if ($.isEmptyObject(inst)) {
			// 	return false;
			// }
			// date = inst.options.calendar.determineDate(date,
			// 	inst.selectedDates[0] || inst.options.calendar.today(), null,
			// 	inst.options.dateFormat, inst.getConfig());
			// return this._isSelectable(elem, date, inst.options.onDate,
			// 	inst.get('minDate'), inst.get('maxDate'));
		},

		_isSelectable: function (elem, date, onDate, minDate, maxDate) {
			// var dateInfo = (typeof onDate === 'boolean' ? {selectable: onDate} :
			// 	(!$.isFunction(onDate) ? {} : onDate.apply(elem, [date, true])));
			// return (dateInfo.selectable !== false) &&
			// 	(!minDate || date.toJD() >= minDate.toJD()) && (!maxDate || date.toJD() <= maxDate.toJD());
			return true;
		},

		performAction: function (elem, action, obj) {
			var inst = this._getInst(elem);
			if (!$.isEmptyObject(inst) && !this.isDisabled(elem)) {
				var commands = inst.options.commands;
				if (commands[action] && commands[action].enabled.apply(elem, [inst, obj])) {
					commands[action].action.apply(elem, [inst, obj]);
				}
			}
		},

		_applyTitle: function (obj, value) {
			var label = obj.find('.sublevel-title');
			if (label.length > 0) {
				var text = label.data("title")
					.replace(/{xx.value-1}/g, value - 1)
					.replace(/{xx.value}/g, value)
					.replace(/{xx.value\+1}/g, value + 1);
				label.html(text);
			}

			return obj;
		},

		_guid: function () {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		},

		_generateContentTypeRadio: function (inst, obj) {
			var typeRadioBlock = inst.options.renderer.typeRadioBlock;
			var typeRadioItem = inst.options.renderer.typeRadioItem;
			var content = '';
			var plugin = this;
			$.each(obj.items, function (i, v) {
				var guid = plugin._guid();
				content += typeRadioItem
					.replace(/{x.id}/g, (v.id ? v.id : v.name))
					.replace(/{x.name}/g, v.name)
					.replace(/{x.value}/g, v.value)
					.replace(/{x.title}/g, v.title)
					.replace(/{x.desc}/g, v.desc != undefined ? v.desc : '')
					.replace(/{guid}/g, guid)
					.replace(/{counter}/g, (i + 1))
					.replace(/{ncounter}/g, plugin._numToAlpha(i + 1))
					.replace(/{x.checked}/g, ((v.checked !== undefined && v.checked) ? "checked" : ""));
			});

			typeRadioBlock = typeRadioBlock
				.replace(/{x.id}/g, (obj.id ? obj.id : obj.name))
				.replace(/{x.name}/g, obj.name)
				.replace(/{x.value}/g, obj.value)
				.replace(/{x.title}/g, obj.title)
				.replace(/{x.desc}/g, obj.desc != undefined ? obj.desc : '')
				.replace(/{x.min}/g, obj.min)
				.replace(/{x.max}/g, obj.max)
				.replace(/{radioBlock}/g, content);
			return typeRadioBlock;
		},

		_generateContentTypeCheck: function (inst, obj) {
			var typeCheckBlock = inst.options.renderer.typeCheckBlock;
			var typeCheckItem = inst.options.renderer.typeCheckItem;
			var content = '';
			var plugin = this;
			$.each(obj.items, function (i, v) {
				var guid = plugin._guid();
				content += typeCheckItem
					.replace(/{x.id}/g, (v.id ? v.id : v.name))
					.replace(/{x.name}/g, v.name)
					.replace(/{x.value}/g, v.value)
					.replace(/{x.title}/g, v.title)
					.replace(/{x.desc}/g, v.desc != undefined ? v.desc : '')
					.replace(/{guid}/g, guid)
					.replace(/{counter}/g, (i + 1))
					.replace(/{ncounter}/g, plugin._numToAlpha(i + 1))
					.replace(/{x.checked}/g, ((v.checked !== undefined && v.checked) ? "checked" : ""));
			});

			typeCheckBlock = typeCheckBlock
				.replace(/{x.id}/g, (obj.id ? obj.id : obj.name))
				.replace(/{x.name}/g, obj.name)
				.replace(/{x.value}/g, obj.value)
				.replace(/{x.title}/g, obj.title)
				.replace(/{x.desc}/g, obj.desc != undefined ? obj.desc : '')
				.replace(/{x.min}/g, obj.min)
				.replace(/{x.max}/g, obj.max)
				.replace(/{radioBlock}/g, content);
			return typeCheckBlock;
		},

		_generateContentTypeRangeSet: function (inst, obj) {
			var typeRangeSetBlock = inst.options.renderer.typeRangeSetBlock;
			var typeRangeSetItem = inst.options.renderer.typeRangeSetItem;
			var content = '';
			var plugin = this;
			$.each(obj.items, function (i, v) {
				var guid = plugin._guid();
				content += typeRangeSetItem
					.replace(/{x.id}/g, (v.id ? v.id : v.name))
					.replace(/{x.name}/g, v.name)
					.replace(/{x.value}/g, v.value)
					.replace(/{x.title}/g, v.title)
					.replace(/{x.desc}/g, v.desc != undefined ? v.desc : '')
					.replace(/{x.min}/g, v.min)
					.replace(/{x.max}/g, v.max)
					.replace(/{guid}/g, guid)
					.replace(/{counter}/g, (i + 1))
					.replace(/{ncounter}/g, plugin._numToAlpha(i + 1));

			});

			typeRangeSetBlock = typeRangeSetBlock
				.replace(/{x.id}/g, (obj.id ? obj.id : obj.name))
				.replace(/{x.name}/g, obj.name)
				.replace(/{x.value}/g, obj.value)
				.replace(/{x.title}/g, obj.title)
				.replace(/{x.desc}/g, obj.desc != undefined ? obj.desc : '')
				.replace(/{x.min}/g, obj.min)
				.replace(/{x.max}/g, obj.max)
				.replace(/{rangeSetBlock}/g, content);
			return typeRangeSetBlock;
		},

		_generateContentTypeRangeSetCollection: function (inst, obj) {
			var typeRangeSetCollectionBlock = inst.options.renderer.typeRangeSetCollectionBlock;
			var content = '';
			var plugin = this;
			$.each(obj.items, function (ii, vv) {
				content += plugin._generateContentTypeRangeSetCollectionItem(inst, vv, ii);
			});

			typeRangeSetCollectionBlock = typeRangeSetCollectionBlock
				.replace(/{x.id}/g, (obj.id ? obj.id : obj.name))
				.replace(/{x.name}/g, obj.name)
				.replace(/{x.value}/g, obj.value)
				.replace(/{x.title}/g, obj.title)
				.replace(/{x.desc}/g, obj.desc != undefined ? obj.desc : '')
				.replace(/{x.min}/g, obj.min)
				.replace(/{x.max}/g, obj.max)
				.replace(/{x.maxSet}/g, obj.maxSet)
				.replace(/{x.json}/g, JSON.stringify(obj).replace(/"/g, "'"))
				.replace(/{rangeSetCollectionBlock}/g, content);

			return typeRangeSetCollectionBlock;
		},

		_generateContentTypeRangeSetCollectionItem: function (inst, obj, count) {
			var typeRangeSetCollectionItem = inst.options.renderer.typeRangeSetCollectionItem;
			var typeRangeSetCollectionSubItem = inst.options.renderer.typeRangeSetCollectionSubItem;
			var typeRangeSetCollectionSubItemSubLevel = inst.options.renderer.typeRangeSetCollectionSubItemSubLevel;

			var content = '';
			var plugin = this;
			$.each(obj.items, function (i, v) {
				var guid = plugin._guid();
				content += typeRangeSetCollectionSubItem
					.replace(/{x.id}/g, (v.id ? v.id : v.name))
					.replace(/{x.name}/g, v.name)
					.replace(/{x.value}/g, v.value)
					.replace(/{x.title}/g, v.title)
					.replace(/{x.desc}/g, v.desc != undefined ? v.desc : '')
					.replace(/{x.min}/g, v.min)
					.replace(/{x.max}/g, v.max)
					.replace(/{x.type}/g, v.type)
					.replace(/{guid}/g, guid)
					.replace(/{counter}/g, (i + 1))
					.replace(/{ncounter}/g, plugin._numToAlpha(i + 1))
					.replace(/{x.json}/g, JSON.stringify(v).replace(/"/g, "'"));

				if (v.type == 'extended') {
					if (v.value == 0) {
						content = content.replace(/{rangeSetCollectionSubItemSubLevel}/g, "<div class='sublevel-container'></div>");
					}
					else {
						var contentx = '';
						for (var c = 0; c < v.value; c++) {
							var element = plugin._generateContentTypeRangeSetCollectionItemSubLevel(inst, v.items[c], c);
							var elementParsed = plugin._applyTitle($(element), parseInt(v.items[c].value));
							element = $('<div>').append(elementParsed).html();
							contentx += element;
						}

						content = content.replace(/{rangeSetCollectionSubItemSubLevel}/g,
							"<div class='sublevel-container'>{content}</div>".replace(/{content}/g, contentx));
					}
				}
				else {
					content = content.replace(/{rangeSetCollectionSubItemSubLevel}/g, "");
				}
			});

			typeRangeSetCollectionItem = typeRangeSetCollectionItem
				.replace(/{x.id}/g, (obj.id ? obj.id : obj.name))
				.replace(/{x.name}/g, obj.name)
				.replace(/{x.value}/g, obj.value)
				.replace(/{x.title}/g, obj.title)
				.replace(/{x.desc}/g, obj.desc != undefined ? obj.desc : '')
				.replace(/{x.min}/g, obj.min)
				.replace(/{x.max}/g, obj.max)
				.replace(/{counter}/g, (count + 1))
				.replace(/{ncounter}/g, plugin._numToAlpha(count + 1))
				.replace(/{rangeSetCollectionItems}/g, content);
			return typeRangeSetCollectionItem;
		},

		_generateContentTypeRangeSetCollectionItemSubLevel: function (inst, obj, count) {
			var typeRangeSetCollectionSubItemSubLevel = inst.options.renderer.typeRangeSetCollectionSubItemSubLevel;
			var content = '';
			var plugin = this;

			var guid = plugin._guid();
			typeRangeSetCollectionSubItemSubLevel = typeRangeSetCollectionSubItemSubLevel
				.replace(/{x.id}/g, (obj.id ? obj.id : obj.name))
				.replace(/{x.name}/g, obj.name)
				.replace(/{x.value}/g, obj.value)
				.replace(/{x.title}/g, obj.title)
				.replace(/{x.desc}/g, obj.desc != undefined ? obj.desc : '')
				.replace(/{x.min}/g, obj.min)
				.replace(/{x.max}/g, obj.max)
				.replace(/{guid}/g, guid)
				.replace(/{counter}/g, (count + 1))
				.replace(/{ncounter}/g, plugin._numToAlpha(count + 1));
			return typeRangeSetCollectionSubItemSubLevel;
		},

		_generateContent: function (elem, inst) {
			var plugin = this;
			var picker = this._prepare(inst.options.renderer.picker, inst); //$("<div class='picker'></div>")

			var content = '';
			if (inst.options.structure != null) {
				$.each(inst.options.structure,
					function (i, v) {
						switch (v.type) {
							case "radio":
								content += plugin._generateContentTypeRadio(inst, v);
								break;
							case "check":
								content += plugin._generateContentTypeCheck(inst, v);
								break;
							case "rangeSet":
								content += plugin._generateContentTypeRangeSet(inst, v);
								break;
							case "rangeSetCollection":
								content += plugin._generateContentTypeRangeSetCollection(inst, v);
								break;
						}
					}
				);
			}
			picker = picker.replace('{content}', content);
			picker = plugin._parseCommands(picker, inst);

			if (inst.options.isRTL) {
				picker.addClass(inst.options.renderer.rtlClass);
			}

			if ($.isFunction(inst.options.onShow)) {
				inst.options.onShow.apply(elem, [picker, inst]);
			}

			return picker;
		},

		_parseCommands(picker, inst) {
			var addCommand = function (type, open, close, name, classes) {
				if (picker.indexOf('{' + type + ':' + name + '}') === -1) {
					return;
				}
				var command = inst.options.commands[name];
				var date = (inst.options.commandsAsDateFormat ? command.date.apply(elem, [inst]) : null);
				picker = picker.replace(new RegExp('\\{' + type + ':' + name + '\\}', 'g'),
					'<' + open + (command.status ? ' title="' + inst.options[command.status] + '"' : '') +
					' class="' + inst.options.renderer.commandClass + ' ' +
					inst.options.renderer.commandClass + '-' + name + ' ' + classes +
					(command.enabled(inst) ? '' : ' ' + inst.options.renderer.disabledClass) + '">' +
					(date ? date.formatDate(inst.options[command.text], { localNumbers: inst.options.localNumbers }) :
						inst.options[command.text]) + '</' + close + '>');
			};

			for (var name in inst.options.commands) {
				if (inst.options.commands.hasOwnProperty(name)) {
					addCommand('button', 'button type="button"', 'button', name,
						inst.options.renderer.commandButtonClass);
					addCommand('link', 'a href="javascript:void(0)"', 'a', name,
						inst.options.renderer.commandLinkClass);
				}
			}
			picker = $(picker);
			picker.find('.' + inst.options.renderer.commandClass).click(function () {
				if (!$(this).hasClass(inst.options.renderer.disabledClass)) {
					var action = this.className.replace(
						new RegExp('^.*' + inst.options.renderer.commandClass + '-([^ ]+).*$'),
						'$1');
					plugin.performAction(inst.elem, action, $(this));
				}
			})
				.end()
				.find('input[type=radio], input[type=checkbox]').change(function () {
					plugin._saveState(inst.elem, inst);
					if (!inst.options.manualClose) {
						plugin.hide(plugin.curInst);
					}
				});

			return picker;
		},

		_getInputValues: function (obj) {
			var parent = obj.closest(".fields-row");
			var isSublevel = parent.hasClass("fields-row-sublevel");
			if (!isSublevel) {
				var input = parent.find("input[type='text']:not(.sublevel)");
				var span = $("#" + input.data("span-id"));
				var value = input.val();
				var min = input.data("min");
				var max = input.data("max");
				var type = "fields-rangeSet";

				value = ((value) ? parseInt(value) : 0);
				min = ((min) ? parseInt(min) : 0);
				max = ((max) ? parseInt(max) : 1);
				max = (max == -1) ? Math.pow(10, 8) : max; //correct if -1;

				var fields = obj.closest(".fields");
				var sum = fields.find("input[type='text']:not(.sublevel)").map((i, v) => parseInt($(v).val())).get().reduce((a, b) => a + b);
				var sumTrani = 6;
				var maxbox = parseInt(fields.data("max"));
				maxbox = (maxbox == -1) ? Math.pow(10, 8) : maxbox;

				var fieldsRoot = obj.closest(".fields").closest(".fields-rangeSetCollection");
				var maxboxx = null;
				var sumx = null;
				if (fieldsRoot.length > 0) {
					sumx = fieldsRoot.find("input[type='text']:not(.sublevel)").map((i, v) => parseInt($(v).val())).get().reduce((a, b) => a + b);
					maxboxx = parseInt(fieldsRoot.data("max"));
					maxboxx = (maxboxx == -1) ? Math.pow(10, 8) : maxboxx;
					type = obj.closest(".fields-row").length > 0 ? "fields-rangeSetCollectionRow" : "fields-rangeSetCollection";
				}

				return { input: input, value: value, min: min, max: max, sumTrani: sumTrani, sum: sum, sumx: sumx, maxbox: maxbox, maxboxx: maxboxx, type: type, span: span };
			}
			else {
				var input = parent.find("input.sublevel");
				var value = input.val();
				var min = input.data("min");
				var max = input.data("max");
				type = "fields-row-sublevel";

				value = ((value) ? parseInt(value) : 0);
				min = ((min) ? parseInt(min) : 0);
				max = ((max) ? parseInt(max) : 1);
				max = (max == -1) ? Math.pow(10, 8) : max; //correct if -1;

				return { input: input, value: value, min: min, max: max, sum: sum, sumx: null, maxbox: maxbox, maxboxx: null, type: type };
			}
		},

		_numToAlpha: function (num) {
			switch (num) {
				case 1:
					return "اول";
				case 2:
					return "دوم";
				case 3:
					return "سوم";
				case 4:
					return "چهارم";
				case 5:
					return "پنجم";
				case 6:
					return "ششم";
				case 7:
					return "هفتم";
				case 8:
					return "هشتم";
				case 9:
					return "نهم";
				case 10:
					return "دهم";
				case 11:
					return "یازدهم";
				case 12:
					return "دوازدهم";
				case 13:
					return "سیزدهم";
				case 14:
					return "چهاردهم";
				case 15:
					return "پانزدهم";
				case 16:
					return "شانزدهم";
				case 17:
					return "هفدهم";
				case 18:
					return "هجدهم";
				case 19:
					return "نوزدهم";
				case 20:
					return "بیستم";
				default:
					return "";
			}
		},


		_prepare: function (text, inst) {
			var replaceSection = function (type, retain) {
				while (true) {
					var start = text.indexOf('{' + type + ':start}');
					if (start === -1) {
						return;
					}
					var end = text.substring(start).indexOf('{' + type + ':end}');
					if (end > -1) {
						text = text.substring(0, start) +
							(retain ? text.substr(start + type.length + 8, end - type.length - 8) : '') +
							text.substring(start + end + type.length + 6);
					}
				}
			};
			replaceSection('inline', inst.inline);
			replaceSection('popup', !inst.inline);
			var pattern = /\{l10n:([^\}]+)\}/;
			var matches = pattern.exec(text);
			while (matches) {
				text = text.replace(matches[0], inst.options[matches[1]]);
				matches = pattern.exec(text);
			}
			return text;
		}
	});

	var plugin = $.passengersPicker; // Singleton instance

	$(function () {
		$(document).on('mousedown.' + pluginName, plugin._checkExternalClick).
			on('resize.' + pluginName, function () { plugin.hide(plugin.curInst); });
	});

	function isMobile() {
		var check = false;
		(function (a) {
			if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
		})(navigator.userAgent || navigator.vendor || window.opera);
		return check;
	}
	function ClickRemoveErrorCount(click) {
		$(click).find(".passengers-cmd-increaseCounter").click(function () {
			$(".text-error-count").addClass('d-none')
			console.log('tesswt2222')

		})
	}
})(jQuery);